import { render, staticRenderFns } from "./PolicyHelpList3.vue?vue&type=template&id=715d24b8&"
import script from "./PolicyHelpList3.vue?vue&type=script&lang=js&"
export * from "./PolicyHelpList3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports